import { LogModule } from '@/data/config';
import { callHandlerCheckSid, callHandlerConfig } from './callHandler';

import { getJsBridge } from './init';

import { JsBridge, Detector } from '@/interface';
import { isIOS, isMobile, inApp } from '@/modules/detector';
import { loggerWarn, loggerInfo } from '@/modules/logger';
import { setCookie } from '@/modules/cookie';

export { getJsBridge, buildWebViewJsBridge } from './init';
export { formatData } from './common';
export * from './listenHandler';

export * from './callHandler';
export * from './registerHandler';

export const setupWebViewJsBridge = async (
  options?: Detector.IInAppOptions
): Promise<JsBridge.IWebViewData | undefined> => {
  if (!inApp(options)) {
    loggerInfo('Bridge not in APP, skip setup', LogModule.JSBridge);
    return;
  }
  try {
    const bridge = await getJsBridge();
    const configData = await callHandlerConfig(bridge);
    return {
      bridge,
      configData,
    };
  } catch (e) {
    throw new Error(e as any);
  }
};

export interface ICheckSidJsBridge {
  cookieName?: string;
  expires?: number;
  sid?: string;
}

/**
 * IOS 专属方法，获取最新sid, 并设置在 cookie 上
 * @param {string} options[cookieName] 设置cookie Name 默认 HSH5_SID
 * @param {string} options[expires] 设置cookie 过期时间 默认 +1 天
 * @returns
 */
export async function checkSidJsBridge(
  options?: ICheckSidJsBridge
): Promise<JsBridge.ICheckSID | undefined> {
  // 非APP，IOS手机
  if (!inApp() || !isMobile() || !isIOS()) {
    loggerWarn(['checkSidJsBridge', '不在APP IOS系统'], LogModule.JSBridge);
    return;
  }

  const cookieName = options?.cookieName ?? 'HSH5_SID';

  const checkData = await callHandlerCheckSid({
    sid: options?.sid ?? '',
  });

  loggerInfo(['callHandlerCheckSid', '返回数据', checkData], LogModule.JSBridge);
  if (checkData.success && (checkData.data?.sid || checkData.data?.url)) {
    const expires = new Date();
    expires.setDate(expires.getDate() + 1);
    checkData.data?.sid && setCookie(cookieName, checkData.data?.sid, options?.expires ?? +expires);

    loggerInfo(['checkSidJsBridge', '设置cookies', checkData], LogModule.JSBridge);

    return checkData;
  }
}
